import styles from './PDRemove.module.css'
import React, {useEffect, useRef, useState} from "react";
import InputItem from "../../FormTemplate/InputItem/InputItem";
import ErrorLineItem, {ErrorLineItemRef} from "../../FormTemplate/ErrorLineItem/ErrorLineItem";
import useApiQuery from "../../ApiQuery/UseApiQuery";
import WaitLoader from "../../WaitLoader/WaitLoader";
import {useNavigate} from "react-router-dom";
import {useDispatch} from "react-redux";
import {setLoginState, setSlider} from "../../Reducer/GlobalReducer";
export default function PDRemove(){
    const [agree, setAgree] = useState(false)
    const [mode, setMode] = useState(0)
    const errorLineRef = useRef<ErrorLineItemRef>(null)
    const navigate = useNavigate()

    const dispatch = useDispatch();

    const pdRemoveData = useRef()
    const [ldrPdRemove,rsPdRemove,exPdRemove] = useApiQuery("/sell/sim/client/pd/remove","get",pdRemoveData);

    const mockData = useRef(null)
    const [ldrLogout,rsLogout,exLogout] = useApiQuery("/auth/logout","get",mockData);

    useEffect(()=>{
        if(mode === 1)
        {
            exLogout().then((e)=>{
                dispatch(setLoginState(false))
                dispatch(setSlider({
                    sliderMode:0
                }))
                localStorage.setItem('authLogin',"")
                localStorage.setItem('defLogin',"")
                localStorage.setItem('authToken',"")
                localStorage.setItem("isLogin","0")
                localStorage.setItem("acceptCookie","0")

                setTimeout(()=>navigate('/'),3000)
            })

        }

    },[mode])


    const handleRemove = () =>{
        exPdRemove().then((e)=>{
            if(e?.success)
            {


                setMode(1)

                return
            }
            if(errorLineRef?.current)errorLineRef?.current?.show(e?.errorAsString ? e?.errorAsString : "Ошибка сервера",true,2000)

        }).catch((e)=>{
            if(errorLineRef?.current)errorLineRef?.current?.show(e?.errorAsString ? e?.errorAsString : "Ошибка сервера",true,2000)

        })
    }


    return(
        <div className={styles.mainCont}>

            { mode === 1 && <>
                <div className={styles.title}>
                    Разрешение отозвано, сейчас вы будете перенаправлены на главную страницу
                </div>
            </>}

            { mode ===0 &&<>
                <div className={styles.title}>
                    Это форма для отзыва разрешения на обработку персональных данных. Отзывая разрешение, мы уничтожаем Все персональные данные о Вас. Если у Вас есть еще не завершенные заказы, то при отзыве, мы не сможем их
                    завершить, не сможем зарегистрировать еще не зарегестрированные sim - карты. Если Вы отзываете разрешение на использование персональных данных при еще не завершенных заказах, мы не несем ответственности
                    за завершение заказа, оплаченные средства не будут возмещены, так как у нас не останется никаких данных о Вас. При отзыве разрешения, удаляется так же личный кабинет.




                </div>

                <form className={styles.agree}>
                    <div className="row g-3 mb-3">
                        <div className="col-12 ">
                            <div className="form-check">
                                <input className="form-check-input" type="checkbox" id="gridCheck"
                                       checked={agree}
                                       onChange={(e)=>setAgree( !agree)}

                                ></input>
                                <label className="form-check-label col-form-label-sm" htmlFor="gridCheck">
                                    С информацией ознакомлен, даю согласие
                                </label>
                            </div>
                        </div>

                    </div>

                </form>

                <div style={{height:"25px"}}>
                    <ErrorLineItem ref={errorLineRef} ></ErrorLineItem>
                </div>
                <div className={styles.btnCont}>
                    <button type="button" className="btn btn-secondary "
                        onClick={()=>handleRemove()}
                        disabled={!agree}
                    >Отозвать</button>
                    <WaitLoader loading={ldrPdRemove} api={rsPdRemove} onlyLoading={true}>

                    </WaitLoader>


                </div>



            </>}





        </div>
    )
}